/*
 * Wunschzettel (sections/wunschzettel.liquid, snippets/wunschzettel-tile.liquid)
 *
 * - Jede Kachel bringt ihre Daten als JSON mit (data-tile-json):
 *   p = Produkte {id: {t, h, u, n}}, v = Varianten {id: {p, l, pr, a, i, o}}
 *   n ist die Nummer vom Papier-Wunschzettel (0 = Sortimentsliste).
 * - Bundles mit vielen Varianten liefern nur die Startvariante mit, der Rest
 *   kommt bei Bedarf ueber /products/<handle>.js. Unbekannte Varianten aus
 *   geteilten Links werden ueber /variants/<id> (Weiterleitung aufs Produkt) aufgeloest.
 * - Wuensche liegen im localStorage (nur Komfort, die Seite geht auch ohne).
 * - Geteilter Link: ?fuer=<Name>&w=<Varianten-IDs base36, mit Punkt getrennt>
 * - Bestellungen ueber den Wunschzettel bekommen das Cart-Attribut _wunschzettel.
 * - Bewusst keine Preise auf der Seite, Preise erst im Warenkorb.
 * - Kein jQuery: custom.js laeuft vor jQuery und bricht ab, siehe Memory-Notiz.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'hh24-wunschzettel-v1';
  var MAX_WISHES = 30;
  var PAPER_MEDIUMS = ['pdf', 'paketbeilage'];

  function readStore() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function writeStore(state) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) {
      /* privater Modus o. ae.: Zettel lebt dann nur bis zum Neuladen */
    }
  }

  function encodeId(id) {
    return Number(id).toString(36);
  }

  function decodeId(s) {
    var n = parseInt(s, 36);
    return isFinite(n) && n > 0 ? String(n) : null;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function cleanName(s) {
    return String(s || '').replace(/[<>]/g, '').trim().slice(0, 30);
  }

  function imgUrl(src) {
    if (!src) return '';
    var url = src.indexOf('//') === 0 ? 'https:' + src : src;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=600';
  }

  function track(action, params) {
    var payload = Object.assign({ wunschzettel_action: action }, params || {});
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'wunschzettel_' + action, payload);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: 'wunschzettel_' + action }, payload));
    }
  }

  class WunschZettel extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.products = {};
      this.variants = {};
      this.byProduct = {};
      this.loaded = {};
      this.loading = {};
      this.readTileData();

      var saved = readStore() || {};
      this.state = {
        name: cleanName(saved.name),
        items: (saved.items || []).map(String)
      };
      this.params = new URLSearchParams(window.location.search);

      this.tiles = Array.prototype.slice.call(this.querySelectorAll('[data-tile]'));
      this.nameInput = this.querySelector('[data-name-input]');
      if (this.nameInput) this.nameInput.value = this.state.name;

      this.bind();
      this.buildNav();
      this.initBar();

      if (PAPER_MEDIUMS.indexOf(this.params.get('utm_medium')) !== -1) {
        var hint = this.querySelector('[data-paper-hint]');
        if (hint) hint.hidden = false;
      }

      var self = this;
      this.ensureVariants(this.state.items).then(function () {
        self.state.items = self.state.items.filter(function (id) { return self.variants[id]; });
        self.tiles.forEach(function (tile) { self.initTile(tile); });
        self.renderList();
      });

      this.initGift();
    }

    /* ---------------- Daten ---------------- */

    readTileData() {
      var self = this;
      this.querySelectorAll('[data-tile-json]').forEach(function (el) {
        try {
          var d = JSON.parse(el.textContent);
          Object.keys(d.p || {}).forEach(function (pid) {
            if (!self.products[pid] || d.p[pid].n) self.products[pid] = d.p[pid];
          });
          Object.keys(d.v || {}).forEach(function (vid) { self.addVariant(vid, d.v[vid]); });
        } catch (e) {
          /* defekte Kachel ignorieren */
        }
      });
    }

    addVariant(vid, v) {
      vid = String(vid);
      v.p = String(v.p);
      if (!this.variants[vid]) {
        (this.byProduct[v.p] = this.byProduct[v.p] || []).push(vid);
      }
      this.variants[vid] = v;
    }

    loadProduct(handle) {
      if (this.loading[handle]) return this.loading[handle];
      var self = this;
      this.loading[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { if (!r.ok) throw new Error('Produkt nicht gefunden'); return r.json(); })
        .then(function (prod) {
          var pid = String(prod.id);
          if (!self.products[pid]) {
            self.products[pid] = { t: prod.title, h: prod.handle, u: prod.url || '/products/' + prod.handle, n: 0 };
          }
          var single = prod.variants.length === 1 && prod.variants[0].title === 'Default Title';
          prod.variants.forEach(function (v) {
            if (self.variants[String(v.id)]) return;
            self.addVariant(v.id, {
              p: pid,
              l: single ? '' : v.title,
              pr: v.price,
              a: !!v.available,
              i: imgUrl(v.featured_image ? v.featured_image.src : prod.featured_image),
              o: v.options
            });
          });
          self.loaded[pid] = true;
          return pid;
        })
        .catch(function () { return null; });
      return this.loading[handle];
    }

    resolveVariant(vid) {
      var self = this;
      return fetch('/variants/' + encodeURIComponent(vid), { redirect: 'follow' })
        .then(function (r) {
          var m = /\/products\/([^/?#]+)/.exec(r.url || '');
          return m ? self.loadProduct(decodeURIComponent(m[1])) : null;
        })
        .catch(function () { return null; });
    }

    ensureVariants(ids) {
      var self = this;
      var missing = ids.filter(function (id) { return !self.variants[id]; });
      return Promise.all(missing.map(function (id) { return self.resolveVariant(id); }));
    }

    info(vid) {
      var v = this.variants[vid];
      if (!v) return null;
      var p = this.products[v.p] || {};
      var url = p.u || '';
      return {
        id: vid,
        nr: p.n || 0,
        t: p.t || '',
        l: v.l,
        pr: v.pr,
        a: v.a,
        i: v.i,
        u: url + (url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + vid
      };
    }

    /* ---------------- Kacheln ---------------- */

    initTile(tile) {
      var self = this;
      if (tile.querySelector('.wz-selects')) {
        var pid = tile.dataset.pid;
        var saved = this.state.items.find(function (id) { return self.variants[id] && self.variants[id].p === pid; });
        if (saved) {
          this.setSelects(tile, this.variants[saved].o || []);
          this.applyVariant(tile, saved);
        } else {
          this.applyVariant(tile, tile.dataset.variant);
        }
        return;
      }
      var chips = Array.prototype.slice.call(tile.querySelectorAll('.wz-chip'));
      var pick = chips.find(function (c) { return self.state.items.indexOf(c.dataset.variant) !== -1; }) ||
        chips.find(function (c) { return !c.classList.contains('is-soldout'); }) ||
        chips[0];
      if (pick) this.selectChip(tile, pick);
    }

    selectChip(tile, chip) {
      tile.querySelectorAll('.wz-chip').forEach(function (c) {
        c.setAttribute('aria-checked', c === chip ? 'true' : 'false');
      });
      var row = chip.parentNode;
      var left = chip.offsetLeft - row.offsetLeft;
      if (left < row.scrollLeft || left + chip.offsetWidth > row.scrollLeft + row.clientWidth - 24) {
        row.scrollLeft = Math.max(0, left - 10);
      }
      this.applyVariant(tile, chip.dataset.variant);
    }

    setSelects(tile, values) {
      tile.querySelectorAll('select[data-option]').forEach(function (sel) {
        var val = values[Number(sel.dataset.option)];
        if (val != null) sel.value = val;
      });
    }

    selectChanged(tile) {
      var self = this;
      var pid = tile.dataset.pid;
      var values = Array.prototype.map.call(tile.querySelectorAll('select[data-option]'), function (s) { return s.value; });
      var find = function () {
        return (self.byProduct[pid] || []).find(function (id) {
          var o = self.variants[id].o || [];
          return values.every(function (val, i) { return o[i] === val; });
        });
      };
      var id = find();
      if (id || !tile.hasAttribute('data-lazy') || this.loaded[pid]) {
        this.applyVariant(tile, id || null);
        return;
      }
      tile.classList.add('is-loading');
      this.loadProduct(tile.dataset.handle).then(function () {
        tile.classList.remove('is-loading');
        self.applyVariant(tile, find() || null);
      });
    }

    applyVariant(tile, vid) {
      var d = vid ? this.info(vid) : null;
      var soldout = tile.querySelector('[data-tile-soldout]');
      var btn = tile.querySelector('[data-action="toggle-wish"]');
      if (!d) {
        tile.dataset.variant = '';
        if (soldout) {
          soldout.textContent = 'Diese Kombination gibt es gerade nicht';
          soldout.hidden = false;
        }
        if (btn) btn.disabled = true;
        this.syncTile(tile);
        return;
      }
      tile.dataset.variant = vid;
      if (btn) btn.disabled = false;
      var img = tile.querySelector('.wz-tile__media img');
      if (img && d.i && img.getAttribute('src') !== d.i) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = d.i;
      }
      if (soldout) {
        soldout.textContent = tile.hasAttribute('data-nr')
          ? 'Gerade ausverkauft, kommt bald wieder'
          : 'Gerade nicht lieferbar, bitte andere Auswahl';
        soldout.hidden = !!d.a;
      }
      this.syncTile(tile);
    }

    syncTile(tile) {
      var id = tile.dataset.variant;
      var on = !!id && this.state.items.indexOf(id) !== -1;
      var btn = tile.querySelector('[data-action="toggle-wish"]');
      if (btn) btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      tile.classList.toggle('is-wished', on);
    }

    toggleWish(tile, btn) {
      var id = tile.dataset.variant;
      if (!id) return;
      var i = this.state.items.indexOf(id);
      if (i === -1) {
        if (this.state.items.length >= MAX_WISHES) return;
        this.state.items.push(id);
        btn.classList.remove('is-pop');
        void btn.offsetWidth;
        btn.classList.add('is-pop');
        track('wish', { wish_number: tile.dataset.nr || 'sortiment' });
      } else {
        this.state.items.splice(i, 1);
      }
      this.save();
      // Dasselbe Produkt kann oben (nummeriert) und in seiner Rubrik stehen
      var self = this;
      this.tiles.forEach(function (t) { self.syncTile(t); });
      this.renderList();
    }

    removeWish(id) {
      var i = this.state.items.indexOf(id);
      if (i === -1) return;
      this.state.items.splice(i, 1);
      this.save();
      var self = this;
      this.tiles.forEach(function (t) { self.syncTile(t); });
      this.renderList();
    }

    showMore(btn) {
      this.querySelectorAll('[data-more][data-list-id="' + btn.dataset.listId + '"]').forEach(function (t) {
        t.hidden = false;
        t.removeAttribute('data-more');
      });
      var row = btn.closest('.wz-more-row');
      if (row) row.remove();
    }

    save() {
      writeStore({ name: this.state.name, items: this.state.items });
    }

    /* ---------------- Rubrik-Leiste ---------------- */

    buildNav() {
      var nav = this.querySelector('[data-nav]');
      var targets = this.querySelectorAll('[data-nav-label]');
      if (!nav || targets.length < 2) return;
      var header = document.querySelector('.shopify-section-group-header-group.cc-header') ||
        document.querySelector('.shopify-section-group-header-group');
      var self = this;
      var ticking = false;
      var place = function () {
        ticking = false;
        var offset = 0;
        if (header) {
          var pos = getComputedStyle(header).position;
          if (pos === 'sticky' || pos === 'fixed') offset = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
        }
        self.style.setProperty('--wz-nav-top', offset + 'px');
      };
      var onScroll = function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(place);
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      place();
      nav.innerHTML = '<div class="wz-nav__inner">' + Array.prototype.map.call(targets, function (t) {
        return '<a class="wz-nav__chip" href="#' + esc(t.id) + '">' + esc(t.dataset.navLabel) + '</a>';
      }).join('') + '</div>';
      nav.hidden = false;
    }

    /* ---------------- Mein Wunschzettel ---------------- */

    sortedItems() {
      var self = this;
      return this.state.items
        .filter(function (id) { return self.variants[id]; })
        .map(function (id, idx) { return { id: id, idx: idx, nr: self.info(id).nr || 1000 }; })
        .sort(function (a, b) { return a.nr - b.nr || a.idx - b.idx; })
        .map(function (x) { return x.id; });
    }

    nrBadge(d, cls) {
      return '<span class="' + cls + (d.nr ? '' : ' is-star') + '">' + (d.nr ? d.nr : '★') + '</span>';
    }

    renderList() {
      var list = this.querySelector('[data-list]');
      var empty = this.querySelector('[data-list-empty]');
      var actions = this.querySelector('[data-list-actions]');
      var items = this.sortedItems();
      var self = this;

      if (list) {
        list.innerHTML = items.map(function (id) {
          var d = self.info(id);
          return '<li class="wz-item">' +
            self.nrBadge(d, 'wz-item__nr') +
            (d.i ? '<img class="wz-item__img" src="' + esc(d.i) + '" alt="" loading="lazy" width="64" height="64">' : '') +
            '<span class="wz-item__text"><strong>' + esc(d.t) + '</strong>' +
            (d.l ? '<span>' + esc(d.l) + '</span>' : '') + '</span>' +
            '<button type="button" class="wz-item__remove" data-action="remove" data-variant="' + esc(id) +
            '" aria-label="' + esc(d.t) + ' vom Wunschzettel nehmen">×</button>' +
            '</li>';
        }).join('');
      }
      if (empty) empty.hidden = items.length > 0;
      if (actions) actions.hidden = items.length === 0;

      this.updateShare();
      this.updateBar();
    }

    shareUrl(medium) {
      var p = new URLSearchParams();
      if (this.state.name) p.set('fuer', this.state.name);
      p.set('w', this.sortedItems().map(encodeId).join('.'));
      p.set('utm_source', 'wunschzettel');
      p.set('utm_medium', medium);
      if (this.dataset.campaign) p.set('utm_campaign', this.dataset.campaign);
      return window.location.origin + window.location.pathname + '?' + p.toString();
    }

    shareText() {
      return this.state.name
        ? 'Hier ist der Hobby-Horse-Wunschzettel von ' + this.state.name + ' 🎄🐴'
        : (this.dataset.shareText || 'Hier ist mein Hobby-Horse-Wunschzettel 🎄🐴');
    }

    updateShare() {
      var wa = this.querySelector('[data-share-whatsapp]');
      if (wa) wa.href = 'https://wa.me/?text=' + encodeURIComponent(this.shareText() + '\n' + this.shareUrl('whatsapp'));
      var mail = this.querySelector('[data-share-mail]');
      if (mail) {
        var subject = this.state.name ? 'Wunschzettel von ' + this.state.name : 'Mein Wunschzettel';
        mail.href = 'mailto:?subject=' + encodeURIComponent(subject) +
          '&body=' + encodeURIComponent(this.shareText() + '\n\n' + this.shareUrl('email'));
      }
      var shareBtn = this.querySelector('[data-action="share"]');
      if (shareBtn) shareBtn.hidden = typeof navigator.share !== 'function';
    }

    copyLink(btn) {
      var url = this.shareUrl('link');
      var done = function () {
        var idle = btn.querySelector('[data-copy-idle]');
        var ok = btn.querySelector('[data-copy-done]');
        if (idle) idle.hidden = true;
        if (ok) ok.hidden = false;
        setTimeout(function () {
          if (idle) idle.hidden = false;
          if (ok) ok.hidden = true;
        }, 2500);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, function () { window.prompt('Link kopieren:', url); });
      } else {
        window.prompt('Link kopieren:', url);
      }
      track('share', { method: 'link' });
    }

    nativeShare() {
      var url = this.shareUrl('share');
      navigator.share({ title: 'Wunschzettel', text: this.shareText(), url: url })
        .then(function () { track('share', { method: 'native' }); })
        .catch(function () {});
    }

    /* ---------------- Drucken ---------------- */

    print() {
      var items = this.sortedItems();
      if (!items.length) return;
      var self = this;
      var url = this.shareUrl('druck');
      var qrSvg = '';
      if (typeof window.qrcode === 'function') {
        var qr = window.qrcode(0, 'M');
        qr.addData(url);
        qr.make();
        qrSvg = qr.createSvgTag({ cellSize: 4, margin: 0, scalable: true });
      }
      var title = this.state.name ? 'Der Wunschzettel von ' + this.state.name : 'Mein Wunschzettel';

      var old = document.querySelector('.wz-print');
      if (old) old.remove();
      var el = document.createElement('div');
      el.className = 'wz-print';
      el.innerHTML =
        '<div class="wz-print__head">' +
          '<img class="wz-print__logo" src="' + esc(this.dataset.logo) + '" alt="HobbyHorse24">' +
          (this.dataset.eyebrow ? '<span class="wz-print__eyebrow">' + esc(this.dataset.eyebrow) + '</span>' : '') +
        '</div>' +
        '<h1 class="wz-print__title">' + esc(title) + '</h1>' +
        '<ol class="wz-print__grid">' + items.map(function (id) {
          var d = self.info(id);
          return '<li>' + self.nrBadge(d, 'wz-print__nr') +
            (d.i ? '<img src="' + esc(d.i) + '" alt="">' : '') +
            '<strong>' + esc(d.t) + '</strong>' + (d.l ? '<span>' + esc(d.l) + '</span>' : '') + '</li>';
        }).join('') + '</ol>' +
        '<div class="wz-print__qr">' +
          (qrSvg ? '<div class="wz-print__code">' + qrSvg + '</div>' : '') +
          '<p><strong>' + esc(this.dataset.printHint || '') + '</strong><span>www.hobbyhorse24.com/wunschzettel</span></p>' +
        '</div>';
      document.body.appendChild(el);

      var imgs = Array.prototype.slice.call(el.querySelectorAll('img'));
      Promise.all(imgs.map(function (img) {
        if (img.complete) return Promise.resolve();
        return new Promise(function (res) { img.onload = res; img.onerror = res; });
      })).then(function () {
        document.body.classList.add('wz-printing');
        var cleanup = function () {
          document.body.classList.remove('wz-printing');
          window.removeEventListener('afterprint', cleanup);
        };
        window.addEventListener('afterprint', cleanup);
        window.print();
        setTimeout(cleanup, 1000);
      });
      track('print', { wishes: items.length });
    }

    /* ---------------- Warenkorb ---------------- */

    addToCart(ids, source) {
      var self = this;
      var items = ids.filter(function (id) { var d = self.info(id); return d && d.a; })
        .map(function (id) { return { id: Number(id), quantity: 1 }; });
      if (!items.length) return Promise.reject(new Error('Diese Wünsche sind gerade leider ausverkauft.'));
      var routes = (window.theme && window.theme.routes) || {};
      var addUrl = (routes.cartAdd || '/cart/add') + '.js';
      var updateUrl = (routes.cartUpdate || '/cart/update') + '.js';
      var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
      return fetch(addUrl, { method: 'POST', headers: headers, body: JSON.stringify({ items: items }) })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.description || data.message || 'Das hat nicht geklappt.');
            return data;
          });
        })
        .then(function () {
          return fetch(updateUrl, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({ attributes: { _wunschzettel: source } })
          }).catch(function () {});
        })
        .then(function () {
          track('add_to_cart', { source: source, items: items.length });
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.querySelectorAll('.header__cart-count-number').forEach(function (n) { n.textContent = cart.item_count; });
          }).catch(function () {});
        });
    }

    setBusy(btn, busy) {
      var idle = btn.querySelector('[data-label-idle]');
      var wait = btn.querySelector('[data-label-busy]');
      if (idle) idle.hidden = busy;
      if (wait) wait.hidden = !busy;
      btn.disabled = busy;
    }

    goToCart() {
      var routes = (window.theme && window.theme.routes) || {};
      window.location.href = routes.cart || '/cart';
    }

    selfAddAll(btn) {
      var self = this;
      var err = this.querySelector('[data-self-error]');
      if (err) err.hidden = true;
      this.setBusy(btn, true);
      this.addToCart(this.sortedItems(), 'selbst').then(function () {
        self.goToCart();
      }).catch(function (e) {
        self.setBusy(btn, false);
        if (err) { err.textContent = e.message; err.hidden = false; }
      });
    }

    /* ---------------- Empfaenger-Ansicht ---------------- */

    initGift() {
      var raw = this.params.get('w');
      if (!raw) return;
      var seen = {};
      var ids = raw.split('.').map(decodeId).filter(function (id) {
        if (!id || seen[id]) return false;
        seen[id] = true;
        return true;
      });
      if (!ids.length) return;

      var self = this;
      var name = cleanName(this.params.get('fuer'));
      this.classList.add('is-gift');
      this.querySelector('[data-gift]').hidden = false;
      ['[data-hero]', '#wuensche', '#mein-wunschzettel', '[data-bar]'].forEach(function (sel) {
        var el = self.querySelector(sel);
        if (el) el.hidden = true;
      });
      this.querySelector('[data-gift-title]').textContent =
        name ? 'Der Wunschzettel von ' + name : 'Ein Hobby-Horse-Wunschzettel';
      var list = this.querySelector('[data-gift-list]');
      list.innerHTML = '<li class="wz-gift__loading">Wunschzettel wird geladen …</li>';

      this.ensureVariants(ids).then(function () {
        self.giftItems = ids.filter(function (id) { return self.variants[id]; }).map(function (id, idx) {
          return { id: id, idx: idx, nr: self.info(id).nr || 1000 };
        }).sort(function (a, b) { return a.nr - b.nr || a.idx - b.idx; }).map(function (x) { return x.id; });

        if (!self.giftItems.length) {
          list.innerHTML = '<li class="wz-gift__loading">Dieser Wunschzettel ist leider nicht mehr aktuell.</li>';
          return;
        }
        list.innerHTML = self.giftItems.map(function (id) {
          var d = self.info(id);
          var action = d.a
            ? '<button type="button" class="wz-btn wz-btn--primary wz-btn--small" data-action="gift-add" data-variant="' + esc(id) + '">' +
                '<span data-label-idle>In den Warenkorb</span><span data-label-busy hidden>…</span></button>'
            : '<span class="wz-gift__soldout">Gerade ausverkauft. <a href="/products/hobbyhorse-geschenkgutschein">Gutschein als Alternative</a></span>';
          return '<li class="wz-gift__item">' +
            self.nrBadge(d, 'wz-item__nr') +
            (d.i ? '<a href="' + esc(d.u) + '" class="wz-gift__img"><img src="' + esc(d.i) + '" alt="" loading="lazy" width="96" height="96"></a>' : '') +
            '<span class="wz-gift__info"><a href="' + esc(d.u) + '"><strong>' + esc(d.t) + '</strong></a>' +
            (d.l ? '<span>' + esc(d.l) + '</span>' : '') + '</span>' +
            '<span class="wz-gift__action">' + action + '</span>' +
            '</li>';
        }).join('');

        var anyAvailable = self.giftItems.some(function (id) { return self.info(id).a; });
        var allBtn = self.querySelector('[data-action="gift-add-all"]');
        if (allBtn) allBtn.hidden = !anyAvailable || self.giftItems.length < 2;

        track('open_shared', { wishes: self.giftItems.length, medium: self.params.get('utm_medium') || '' });
      });
    }

    giftAdd(btn) {
      var self = this;
      var err = this.querySelector('[data-gift-error]');
      if (err) err.hidden = true;
      this.setBusy(btn, true);
      this.addToCart([btn.dataset.variant], 'geschenk').then(function () {
        var cell = btn.parentNode;
        cell.innerHTML = '<span class="wz-gift__done">✓ Im Warenkorb</span>';
        var cart = self.querySelector('[data-gift-cart]');
        if (cart) cart.hidden = false;
      }).catch(function (e) {
        self.setBusy(btn, false);
        if (err) { err.textContent = e.message; err.hidden = false; }
      });
    }

    giftAddAll(btn) {
      var self = this;
      var err = this.querySelector('[data-gift-error]');
      if (err) err.hidden = true;
      this.setBusy(btn, true);
      this.addToCart(this.giftItems || [], 'geschenk').then(function () {
        self.goToCart();
      }).catch(function (e) {
        self.setBusy(btn, false);
        if (err) { err.textContent = e.message; err.hidden = false; }
      });
    }

    /* ---------------- Leiste unten ---------------- */

    initBar() {
      this.bar = this.querySelector('[data-bar]');
      this.listInView = false;
      var listSection = this.querySelector('#mein-wunschzettel');
      var self = this;
      if (listSection && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          self.listInView = entries[0].isIntersecting;
          self.updateBar();
        }, { threshold: 0.15 }).observe(listSection);
      }
      this.updateBar();
    }

    updateBar() {
      if (!this.bar) return;
      var n = this.state.items.length;
      this.bar.hidden = n === 0 || this.listInView || this.classList.contains('is-gift');
      var count = this.bar.querySelector('[data-bar-count]');
      var word = this.bar.querySelector('[data-bar-word]');
      if (count) count.textContent = n;
      if (word) word.textContent = n === 1 ? 'Wunsch' : 'Wünsche';
    }

    /* ---------------- Events ---------------- */

    bind() {
      var self = this;
      this.addEventListener('click', function (e) {
        var chip = e.target.closest('.wz-chip');
        if (chip) {
          self.selectChip(chip.closest('[data-tile]'), chip);
          return;
        }
        var el = e.target.closest('[data-action]');
        if (!el) return;
        switch (el.dataset.action) {
          case 'toggle-wish':
            self.toggleWish(el.closest('[data-tile]'), el);
            break;
          case 'remove':
            self.removeWish(el.dataset.variant);
            break;
          case 'more':
            self.showMore(el);
            break;
          case 'share':
            self.nativeShare();
            break;
          case 'copy':
            self.copyLink(el);
            break;
          case 'print':
            self.print();
            break;
          case 'self-add-all':
            self.selfAddAll(el);
            break;
          case 'gift-add':
            self.giftAdd(el);
            break;
          case 'gift-add-all':
            self.giftAddAll(el);
            break;
          case 'start-own':
            e.preventDefault();
            window.location.href = window.location.pathname + '#wuensche';
            break;
          case 'pdf':
            track('pdf_download');
            break;
        }
      });

      this.addEventListener('change', function (e) {
        if (e.target.matches('select[data-option]')) self.selectChanged(e.target.closest('[data-tile]'));
      });

      var wa = this.querySelector('[data-share-whatsapp]');
      if (wa) wa.addEventListener('click', function () { track('share', { method: 'whatsapp' }); });
      var mail = this.querySelector('[data-share-mail]');
      if (mail) mail.addEventListener('click', function () { track('share', { method: 'email' }); });

      if (this.nameInput) {
        this.nameInput.addEventListener('input', function () {
          self.state.name = cleanName(self.nameInput.value);
          self.save();
          self.updateShare();
        });
      }
    }
  }

  if (!customElements.get('wunsch-zettel')) {
    customElements.define('wunsch-zettel', WunschZettel);
  }
})();
